import parse from 'url-parse';
import root from 'window-or-global';
import {JobFilters} from './jobs.callbacks';
import qs from 'querystringify';
interface Params {
    [key: string]: string | number | undefined;
}

const validFilterKeys = [
    'city',
    'company',
    'country',
    'department',
    'product',
    'remote',
    'state',
    'type'
];

const validFunctionalKeys = ['keyword', 'page'];

export const valueIsValid = (jobFiltersValue) => {
    // '/' is not a valid state value
    if (jobFiltersValue === '/') {
        return false;
    }
    return true;
};

export const filterTypeIsValid = (jobFilterType, hideRemoteFilter) => {
    // if remote eligle filter is hidden
    if (hideRemoteFilter && jobFilterType === 'remote') {
        return false;
    }
    return true;
};

export const getQuery = (): {[key: string]: string | undefined} => {
    if (root.location && root.location.href) {
        const url = parse(root.location.href, true);
        const queryParams = url.query;
        return queryParams;
    }
    return {};
};

export const getQueryStringified = (): string => {
    const queryParams = getQuery();
    const stringifiedQueryParams = qs.stringify(queryParams);
    return stringifiedQueryParams;
};

export const getNoFunctionalQueryStringified = (): string => {
    const queryParams = getQuery();
    const sanitizedParams: Params = {};
    for (const [key, value] of Object.entries(queryParams)) {
        if (validFilterKeys.indexOf(key) === -1 && validFunctionalKeys.indexOf(key) === -1) {
            sanitizedParams[key] = value;
        }
    }
    const stringifiedQueryParams = qs.stringify(sanitizedParams);
    return stringifiedQueryParams;
};

export const getUrlQueryParams = (): Params => {
    const queryParams = getQuery();
    const finalQueryParams: Params = queryParams;
    if (finalQueryParams.page) {
        finalQueryParams.page = +finalQueryParams.page;
    }
    if (finalQueryParams.limit) {
        finalQueryParams.limit = +finalQueryParams.limit;
    }
    if (finalQueryParams.skip) {
        finalQueryParams.skip = +finalQueryParams.skip;
    }
    return finalQueryParams;
};

export const getSanitizedQueryParams = (): Params => {
    const sanitizedParams: Params = {};
    const queryParams = getUrlQueryParams();
    if (queryParams && Object.keys(queryParams).length) {
        for (const key in queryParams) {
            if (Object.prototype.hasOwnProperty.call(queryParams, key)) {
                if (validFilterKeys.indexOf(key) > -1) {
                    sanitizedParams[key] = queryParams[key];
                }
            }
        }
    }
    return sanitizedParams;
};

export const getResultsOffset = (jobResultsPage: number, jobPageSize = 50): number => {
    let results_offset = 0;

    if (jobResultsPage > 0) {
        //Page count starts with 1
        results_offset = (jobResultsPage - 1) * jobPageSize;
    }

    return results_offset;
};

export const generateFiltersQueryParams = (
    jobsFilters: JobFilters,
    search: string,
    jobResultsPage: number,
    hideRemoteFilter?: boolean
): string => {
    const queryParams = getQuery();
    const finalParams: Params = {};

    let filtersQueryParams = '';

    //add jobFilters to params
    for (const [key, value] of Object.entries(jobsFilters)) {
        if (filterTypeIsValid(key, hideRemoteFilter) && valueIsValid(value[0])) {
            finalParams[key] = value.join('+');
        }
    }

    //add any additional non jobFilter url params
    for (const [key, value] of Object.entries(queryParams)) {
        if (
            !finalParams[key] &&
            validFilterKeys.indexOf(key) === -1 &&
            validFunctionalKeys.indexOf(key) === -1
        ) {
            finalParams[key] = value;
        }
    }

    //build the filterQuery string
    for (const [key, value] of Object.entries(finalParams)) {
        filtersQueryParams += `&${key.toLocaleLowerCase()}=${encodeURIComponent(`${value}`)}`;
    }

    //make sure keywrod is appended
    if (search) {
        filtersQueryParams += `&keyword=${encodeURIComponent(search)}`;
    }

    //make sure page is appended
    if (jobResultsPage) {
        filtersQueryParams += `&page=${jobResultsPage}`;
    }

    //remove first & from string
    return filtersQueryParams.substr(1);
};

export const getInitialFiltersFromQuery = (hideRemoteFilter): JobFilters => {
    const jobsFilters: JobFilters = {};
    const currentQuery = getUrlQueryParams();
    if (currentQuery && Object.keys(currentQuery).length) {
        for (const key in currentQuery) {
            if (Object.prototype.hasOwnProperty.call(currentQuery, key)) {
                if (validFilterKeys.indexOf(key) > -1) {
                    if (filterTypeIsValid(key, hideRemoteFilter)) {
                        const value: string | number = currentQuery[key] || '';
                        if (value && valueIsValid(value)) {
                            if (typeof value === 'string') {
                                jobsFilters[key] = value.split('+');
                            } else {
                                jobsFilters[key] = [`${value}`];
                            }
                        }
                    }
                }
            }
        }
    }
    return jobsFilters;
};
